import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface TeacherRecentStudent {
  teacher_id: string;
  nickname: string | null;
  full_name: string | null;
  student_id: string;
  student_nickname: string | null;
  student_first_name: string | null;
  student_last_name: string | null;
  teaching_year: number;
  teaching_month: number;
  total_hours: number;
  total_class: number;
}

export function useTeacherRecentStudents(year: number, month: number) {
  return useQuery({
    queryKey: ['teacher-recent-students', year, month],
    queryFn: async () => {
      const { data, error } = await (supabase as any)
        .from('teacher_recent_students')
        .select('*')
        .eq('teaching_year', year)
        .eq('teaching_month', month)
        .order('teacher_id');

      if (error) {
        console.error('Error fetching teacher recent students:', error);
        throw error;
      }

      return data as TeacherRecentStudent[];
    },
  });
}
